import { ts } from '_core';

import { getName, validate } from './helpers';
import { DraftParams } from './types';

export default [
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.SIGNAL_ANNUALIZED_AVERAGE_BUCKETED_RETURN,
    title: 'Equal-weighted Annualized Returns by Bucket',
    helpLabel: 'whou953v',
    form: true,
    defaultParams: {
      statistics_type: 'return',
      weights: 'equal',
      histories: ['1 Year', '3 Years', '5 Years', 'Full'],
      ui_transformation: 'ANNUALIZED',
    } as DraftParams,
    neededFiles: ['bucketed_returns'],
    tags: [
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.SIGNAL,
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.ALPHA_MODEL,
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.COMMON_ALPHA_MODEL,
    ],

    getName,
    validate,
  },
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.SIGNAL_ANNUALIZED_AVERAGE_BUCKETED_RISK,
    title: 'Equal-weighted Annualized Risk by Bucket',
    helpLabel: 'u4puhrd9',
    form: true,
    defaultParams: {
      statistics_type: 'risk',
      weights: 'equal',
      histories: ['1 Year', '3 Years', '5 Years', 'Full'],
      ui_transformation: 'ANNUALIZED',
    } as DraftParams,
    neededFiles: ['bucketed_returns'],
    tags: [
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.SIGNAL,
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.ALPHA_MODEL,
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.COMMON_ALPHA_MODEL,
    ],

    getName,
    validate,
  },
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.SIGNAL_ANNUALIZED_AVERAGE_BUCKETED_ADJUSTED,
    title: 'Equal-weighted Annualized Risk Adjusted Returns by Bucket',
    helpLabel: 'zmh9kles',
    form: true,
    defaultParams: {
      statistics_type: 'adjusted',
      weights: 'equal',
      histories: ['1 Year', '3 Years', '5 Years', 'Full'],
      ui_transformation: 'ANNUALIZED',
    } as DraftParams,
    neededFiles: ['bucketed_returns'],
    tags: [
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.SIGNAL,
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.ALPHA_MODEL,
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.COMMON_ALPHA_MODEL,
    ],

    getName,
    validate,
  },
] satisfies ts.types.analysis.WidgetConfig[];
